import IconClose from "assets/icons/Close";
import IconMenu from "assets/icons/Menu";
import classNames from "classnames";
import Button from "components/Button";
import { motion } from "framer-motion";
import { useAppScroll } from "hooks";
import React, { useCallback, useMemo, useState } from "react";
import styles from "./styles.module.scss";

interface Props {
  onOpenQuotationModal: () => void;
}

const Header: React.FC<Props> = ({ onOpenQuotationModal }) => {
  const { scrollTo } = useAppScroll();

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const sections = useMemo(
    () => [
      {
        path: "/about",
        label: "About",
      },
      {
        path: "/services",
        label: "Services",
      },
      {
        path: "/projects",
        label: "Projects",
      },
      {
        path: "/contact",
        label: "Contact",
      },
    ],
    []
  );

  const handleClick = useCallback(
    (id: string) => {
      scrollTo({ elementId: id.toLowerCase(), offset: 20 });
      setIsMenuOpen(false);
    },
    [scrollTo]
  );

  const handleGetQuote = useCallback(() => {
    setIsMenuOpen(false);
    onOpenQuotationModal();
  }, [onOpenQuotationModal]);

  return (
    <>
      <motion.div className={styles.container}>
        <div className={styles.content}>
          <Button
            className={styles.homeButton}
            href="/home"
            onClick={() => handleClick("home")}
          >
            <div
              className={styles.logo}
              style={{ backgroundImage: `url('/logo.png')` }}
            />
            <div className={styles.title}>Renewable PH</div>
          </Button>

          <div className={styles.sections}>
            {sections.map((section) => (
              <Button
                className={styles.button}
                key={section.path}
                href={section.path}
                onClick={() => handleClick(section.label)}
                type="link"
              >
                {section.label}
              </Button>
            ))}
          </div>

          <Button
            className={styles.contactButton}
            type="primary"
            onClick={handleGetQuote}
          >
            Get a Quote
          </Button>

          <Button
            className={styles.menuButton}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <IconMenu className={styles.icon} />
          </Button>
        </div>
      </motion.div>

      <div
        className={classNames(styles.overlay, isMenuOpen && styles.visible)}
        onClick={() => setIsMenuOpen(false)}
      />

      <div className={classNames(styles.menu, isMenuOpen && styles.visible)}>
        <div className={styles.header}>
          <Button
            className={styles.closeButton}
            onClick={() => setIsMenuOpen(false)}
          >
            <IconClose className={styles.icon} />
          </Button>
        </div>

        {sections.map((section) => (
          <Button
            className={styles.button}
            key={section.path}
            href={section.path}
            onClick={() => handleClick(section.label)}
            type="link"
          >
            {section.label}
          </Button>
        ))}

        <Button
          className={classNames(styles.contactButton, styles.modal)}
          href="/quote"
          type="primary"
        >
          Get a Quote
        </Button>
      </div>
    </>
  );
};

export default Header;
